// API Configuration
// This will use the environment variable from Vercel, or the fallback URL
// You can also hardcode your backend URL here directly
const API_URL = process.env.REACT_APP_API_URL || 'https://shari-backend.vercel.app';

export default API_URL;
